import client from './client';

const PATH = '/api/festivals/festivals/';

const list = (params = {}) => client.get(PATH, { params }).then((r) => r.data);
const detail = (id) => client.get(`${PATH}${id}/`).then((r) => r.data);

export const festivalApi = {
  list,
  detail,

  create(payload) {
    return client.post(PATH, payload).then((r) => r.data);
  },

  update(id, payload) {
    return client.patch(`${PATH}${id}/`, payload).then((r) => r.data);
  },

  remove(id) {
    return client.delete(`${PATH}${id}/`).then((r) => r.data);
  },
};